// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { AppProvider } from './context/AppContext';
// import HomePage from './pages/HomePage';
// import CategoryPage from './pages/CategoryPage';
// import ArticlePage from './pages/ArticlePage';
// import VideoPage from './pages/VideoPage';
// import VideosPage from './pages/VideosPage';
// import LiveTVPage from './pages/LiveTVPage';
// import SearchPage from './pages/SearchPage';
// import AdminPage from './pages/AdminPage';
// import JokesPage from './pages/JokesPage';
// import SingleJokePage from './pages/SingleJokePage';
// import Layout from './components/Layout/Layout';

// function App() {
//     return (
//         <AppProvider>
//             <Router>
//                 <Routes>
//                     <Route path="/admin/*" element={<AdminPage />} />

//                     <Route path="/" element={
//                         <Layout>
//                             <HomePage />
//                         </Layout>
//                     } />

//                     <Route path="/category/:category" element={
//                         <Layout>
//                             <CategoryPage />
//                         </Layout>
//                     } />

//                     <Route path="/article/:id" element={
//                         <Layout>
//                             <ArticlePage />
//                         </Layout>
//                     } />

//                     <Route path="/video/:id" element={
//                         <Layout>
//                             <VideoPage />
//                         </Layout>
//                     } />

//                     <Route path="/videos" element={
//                         <Layout>
//                             <VideosPage />
//                         </Layout>
//                     } />

//                     <Route path="/live-tv" element={
//                         <Layout>
//                             <LiveTVPage />
//                         </Layout>
//                     } />

//                     <Route path="/search" element={
//                         <Layout>
//                             <SearchPage />
//                         </Layout>
//                     } />

//                     <Route path="/jokes" element={
//                         <Layout>
//                             <JokesPage />
//                         </Layout>
//                     } />

//                     <Route path="/joke/:id" element={
//                         <Layout>
//                             <SingleJokePage />
//                         </Layout>
//                     } />


//                 </Routes>
//             </Router>
//         </AppProvider>
//     );
// }

// export default App;


import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import ArticlePage from './pages/ArticlePage';
import VideoPage from './pages/VideoPage';
import VideosPage from './pages/VideosPage';
import LiveTVPage from './pages/LiveTVPage';
import SearchPage from './pages/SearchPage';
import JokesPage from './pages/JokesPage';
import SingleJokePage from './pages/SingleJokePage';
import AdminPage from './pages/AdminPage';
import Layout from './components/Layout/Layout';

function App() {
    return (
        <AppProvider>
            <Router>
                <Routes>
                    <Route path="/admin/*" element={<AdminPage />} />
                    <Route path="/" element={<Layout><HomePage /></Layout>} />
                    <Route path="/category/:category" element={<Layout><CategoryPage /></Layout>} />

                    {/* ✅ Updated routes to support both ID and slug */}
                    <Route path="/article/:slug" element={<Layout><ArticlePage /></Layout>} />
                    <Route path="/video/:slug" element={<Layout><VideoPage /></Layout>} />
                    <Route path="/joke/:slug" element={<Layout><SingleJokePage /></Layout>} />

                    <Route path="/videos" element={<Layout><VideosPage /></Layout>} />
                    <Route path="/live-tv" element={<Layout><LiveTVPage /></Layout>} />
                    <Route path="/search" element={<Layout><SearchPage /></Layout>} />
                    <Route path="/jokes" element={<Layout><JokesPage /></Layout>} />
                </Routes>
            </Router>
        </AppProvider>
    );
}

export default App;